import { useEffect, useRef, useState } from "react";
import { analyticsApi, ApiError } from "@/services/apiClient";

// Canonical Identity Phase 1 (2026-09-10) — canonicalUserId 로 rollup 을 조회한다.
// 매핑이 없으면 백엔드가 404(CANONICAL_NOT_FOUND) → notFound=true 로 노출해 호출부가
// 기존 sub 조회(userDetail)로 fallback 하게 한다. 다른 오류는 error 로 표면화.
export function useCanonicalUser(canonicalUserId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(canonicalUserId));
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  useEffect(() => {
    if (!canonicalUserId) {
      setData(null);
      setLoading(false);
      setNotFound(false);
      setError(null);
      return;
    }
    let cancelled = false;
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setNotFound(false);
    setError(null);

    (async () => {
      try {
        const r = await analyticsApi.canonicalUser(canonicalUserId, undefined, ctrl.signal);
        if (!cancelled) setData(r);
      } catch (e) {
        if (cancelled || e.name === "AbortError") return;
        if (e instanceof ApiError && e.status === 404) {
          setNotFound(true);   // fallback 신호 — 호출부가 sub 조회로 되돌아간다
        } else {
          setError(e);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
      ctrl.abort();
    };
  }, [canonicalUserId]);

  return { data, loading, notFound, error };
}
